import { getCsrfToken } from './GetCsrfToken';
import DeviceId from '../flows/DeviceId';

// Sends a lightweight client-side event to the server so it is recorded in the
// same Application Insights customEvents stream as the server payment journey.
// Logging must never break the payment flow, so every failure is swallowed.
export const logClientEvent = (name, properties = {}) => {
  try {
    const safeProps = {};
    Object.keys(properties || {}).forEach(key => {
      const value = properties[key];
      safeProps[key] = value === null || value === undefined ? '' : String(value);
    });

    fetch('api/Braintree/LogClientEvent', {
      method: 'post',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken(),
        'DEVICE_ID': DeviceId.DEVICE_ID
      },
      body: JSON.stringify({ Name: name, Properties: safeProps })
    }).catch(() => {});
  } catch (e) {
    // Never let logging break the payment flow.
  }
};
